export default __webpack_public_path__ + "static/media/back.a56d2d02.jpg";